var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMerge = function SvgMerge(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M2.125 3a1.124 1.124 0 1 0 0 2.25H5.54c.341 0 .665.154.879.421L9.682 9.75 6.42 13.826a1.13 1.13 0 0 1-.879.422H2.125a1.124 1.124 0 1 0 0 2.25H5.54a3.39 3.39 0 0 0 2.637-1.266l3.486-4.358h2.833v1.124a1.129 1.129 0 0 0 1.923.798l2.25-2.25a1.123 1.123 0 0 0 0-1.588l-2.25-2.25a1.12 1.12 0 0 0-1.227-.242 1.125 1.125 0 0 0-.696 1.04v1.125h-2.833L8.178 4.265A3.37 3.37 0 0 0 5.54 3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMerge);
export default ForwardRef;